
interface ComponentStyleObject {
  [key: string]: any;
}

interface LinkConfig {
  components: {
    Link: {
      baseStyle: ComponentStyleObject;
      _hover?: ComponentStyleObject;
    };
  };
}

export const linkStyles: LinkConfig = {
  components: {
    Link: {
      baseStyle: {
        textDecoration: "none",
        boxShadow: "none",
        _focus: {
          boxShadow: "none",
        },
        _active: {
          boxShadow: "none",
        },
        _hover: {
          textDecoration: "underline",
          border: "none",
        },
      },
      _hover: {
        textDecoration: "none",
        border: "none",
      },
    },
  },
};
